module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intended-users"
  }, [_c('div', {
    attrs: {
      "id": "yxkhdivid"
    }
  }, [_c('div', {
    staticClass: "toolbar",
    staticStyle: {
      "height": "26px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success",
      "size": "small",
      "icon": "plus"
    },
    on: {
      "click": _vm.openEditDialog
    }
  }, [_vm._v("新增")]), _vm._v(" "), (this.$route.name === '意向客户列表(查看)') ? _c('el-button', {
    attrs: {
      "type": "info",
      "size": "small",
      "icon": "star-on"
    },
    on: {
      "click": function($event) {
        _vm.setMajor(1)
      }
    }
  }, [_vm._v("设为重点")]) : _vm._e(), _vm._v(" "), (this.$route.name === '重点客户列表(查看)') ? _c('el-button', {
    attrs: {
      "type": "info",
      "size": "small",
      "icon": "star-off"
    },
    on: {
      "click": function($event) {
        _vm.setMajor(0)
      }
    }
  }, [_vm._v("设为意向")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "search-switch",
    style: (_vm.bgStyle)
  }, [_c('el-button', {
    staticClass: "search-btn",
    attrs: {
      "type": "info",
      "size": "small"
    },
    on: {
      "click": _vm.toggleSearch
    }
  }, [_vm._v("高级搜索\n                    "), _c('i', {
    staticClass: "el-icon--right",
    class: _vm.arrowClass
  })])], 1)], 1), _vm._v(" "), _c('complex-search', {
    on: {
      "search": _vm.complexSearch,
      "reset": _vm.resetFilterData
    },
    model: {
      value: (_vm.searchVisiable),
      callback: function($$v) {
        _vm.searchVisiable = $$v
      },
      expression: "searchVisiable"
    }
  }), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "element-loading-text": "拼命加载中",
      "data": _vm.lists,
      "border": "",
      "highlight-current-row": ""
    },
    on: {
      "current-change": _vm.selectRow
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "序号",
      "width": "70"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Customer",
      "label": "公司",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "C_Name",
      "label": "主联系人",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "C_Tel",
      "label": "电话",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ProjectTypeNames",
      "label": "所属项目",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "AgentStatusName",
      "label": "审核状态",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "AuditOpinion",
      "label": "审核意见",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ProvincesName",
      "label": "省份",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "CityName",
      "label": "城市",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "AreaName",
      "label": "县市",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "CustomerSourceName",
      "label": "客户来源",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "CustomerLevelName",
      "label": "意向级别",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "DepartmentName",
      "label": "部门",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "EmployeeName",
      "label": "所属业务经理",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Create_Date",
      "label": "创建时间",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "LastFollow",
      "label": "最后跟进",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right",
      "width": "360"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "uopt-ctn"
        }, [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small",
            "icon": "search"
          },
          on: {
            "click": function($event) {
              _vm.showDetails(scope.row.Id)
            }
          }
        }, [_vm._v("查看")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "warning",
            "size": "small",
            "icon": "edit"
          },
          on: {
            "click": function($event) {
              _vm.goToModify(scope.row.Id)
            }
          }
        }, [_vm._v("修改")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small",
            "icon": "setting"
          },
          on: {
            "click": function($event) {
              _vm.transfer(scope.row)
            }
          }
        }, [_vm._v("转移")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "btm-action",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "current-page": _vm.pageIndex,
      "page-sizes": _vm.pageSizes,
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.totalSize * 1
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('edit-dialog', {
    ref: "editdialog",
    on: {
      "reload-list": _vm.getList
    },
    model: {
      value: (_vm.editDialogVisiable),
      callback: function($$v) {
        _vm.editDialogVisiable = $$v
      },
      expression: "editDialogVisiable"
    }
  }), _vm._v(" "), _c('edit-dialog', {
    ref: "updateDialog",
    attrs: {
      "isReadOnly": _vm.isReadOnlyLook,
      "edit-data": _vm.editData,
      "modify": ""
    },
    on: {
      "reload-list": _vm.getList,
      "closeDialog": _vm.closeModifyDialog
    },
    model: {
      value: (_vm.modifyDialogVisiable),
      callback: function($$v) {
        _vm.modifyDialogVisiable = $$v
      },
      expression: "modifyDialogVisiable"
    }
  }), _vm._v(" "), _c('apply-dialog', {
    ref: "applyZzDialog",
    attrs: {
      "id": _vm.currentcustomerId
    },
    on: {
      "reload-list": _vm.getList
    },
    model: {
      value: (_vm.applyDialogVisiable),
      callback: function($$v) {
        _vm.applyDialogVisiable = $$v
      },
      expression: "applyDialogVisiable"
    }
  }), _vm._v(" "), _c('follow-up-dialog', {
    ref: "follow",
    attrs: {
      "data": _vm.followUpList,
      "follow-item": _vm.followItem,
      "total-size": _vm.followUpTotalSize
    },
    on: {
      "refresh-data": _vm.refreshFollowUpList,
      "add": _vm.addFollowUpItem,
      "get-followup-item": _vm.getFollowUpItem,
      "update": _vm.updateFollowUpItem,
      "delete": _vm.delFollowUpItem
    },
    model: {
      value: (_vm.followUpListVisiable),
      callback: function($$v) {
        _vm.followUpListVisiable = $$v
      },
      expression: "followUpListVisiable"
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "转移",
      "visible": _vm.transferVisiable,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.transferVisiable = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "100px",
      "model": _vm.transferForm
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "公司"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "260px"
    },
    model: {
      value: (_vm.transferForm.company),
      callback: function($$v) {
        _vm.$set(_vm.transferForm, "company", $$v)
      },
      expression: "transferForm.company"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "请选择员工"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "260px",
      "margin-right": "10px"
    },
    attrs: {
      "readonly": "readonly"
    },
    model: {
      value: (_vm.selectEmployeeName),
      callback: function($$v) {
        _vm.selectEmployeeName = $$v
      },
      expression: "selectEmployeeName"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showEmployeeDialog
    }
  }, [_vm._v("选择员工")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.transferVisiable = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.transferSubmit
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('selectStaffDialog', {
    ref: "refSelectStaffDialog",
    on: {
      "selectedStaff": _vm.selectedStaff
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2069c56f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ViewCRMAgentManage/IntendedUsers.vue
// module id = 1413
// module chunks = 1